<template>
  <div
    class="navbar-container d-flex content align-items-center"
    style="background-color:#fff; height: 80px;"
  >

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none d-lg-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
        >
          <b-img
            style="height: 60px; padding-right: 5px;"
            src="@/assets/images/logo/nakorn_nont_logo.png"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <b-img
        style="height: 60px; padding-right: 5px;"
        src="@/assets/images/logo/nakorn_nont_logo.png"
      />
    </div>

    <div class="nav align-items-center ml-auto d-none d-lg-flex">
      <b-img
        style="height: 60px; padding-right: 5px;"
        src="@/assets/images/logo/FirstTech_Logo.png"
      />
    </div>
  </div>
</template>

<script>
import {
  BLink, BImg,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BLink,
    // BNavbarNav,
    // BNavItemDropdown,
    // BDropdownItem,
    // BDropdownDivider,
    // BAvatar,
    BImg,

    // Navbar Components
    // DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
